import {listFomaPagamento} from '@/domain/financeiro/services/formasPagamento'
import window from './window/window.js'

export default {
  pageTitle: 'Formas de Pagamento',
  columns: [
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    {
      name: 'codigo',
      required: true,
      label: 'Código Único',
      align: 'left',
      field: 'codigo',
      sortable: true,
      parser: function (props) {
        return props.codigo
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: listFomaPagamento,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    }
  }
}
